import React, {FC, ReactElement} from 'react';
import cn from 'classnames';

import Question from 'shared/ui/icons/General/Question';

import Hint, {HintPlacement} from './Hint';

import styles from './Hint.module.scss';

interface IHintProps{
    children: ReactElement | string | number,
    placement?: HintPlacement,
    className?: string | React.ReactNode,
    color?: string,
}

const HintQuestion: FC<IHintProps> = ({children, placement, className, color}) => {
    return (
        <Hint
            trigger={
                <span className={cn(styles.question, className)}>
                    <Question color={color}/>
                </span>}
            placement={placement}
            className={styles.widthHint}
        >
            {children}
        </Hint>
    );
};

export default HintQuestion;
